'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocManager = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _FilePreview = require('../FilePreview/FilePreview');

var _FilePreview2 = _interopRequireDefault(_FilePreview);

var _Container = require('./components/Container.DocManager');

var _Container2 = _interopRequireDefault(_Container);

var _Header = require('./components/Header.DocManager');

var _Header2 = _interopRequireDefault(_Header);

var _Grid = require('./components/Grid.DocManager');

var _Grid2 = _interopRequireDefault(_Grid);

var _File = require('./components/File.DocManager');

var _File2 = _interopRequireDefault(_File);

var _Folder = require('./components/Folder.DocManager');

var _Folder2 = _interopRequireDefault(_Folder);

var _Uploader = require('./components/Uploader.DocManager');

var _Uploader2 = _interopRequireDefault(_Uploader);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // Components


var DocManager = function (_Component) {
  _inherits(DocManager, _Component);

  function DocManager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DocManager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DocManager.__proto__ || Object.getPrototypeOf(DocManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      folder: [],
      open: [],
      selected: []
    }, _this.pathAndType = function () {
      var folder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.folder;
      if (!folder.length) return {
        path: null,
        type: null
      };
      if (folder.length === 1) return {
        path: null,
        type: folder[0]
      };
      var folders = [].concat(_toConsumableArray(folder));
      var type = folders.pop();
      return {
        path: folders.join('/'),
        type: type
      };
    }, _this.documents = function () {
      var documents = _this.props.documents;

      var _this$pathAndType = _this.pathAndType(),
          path = _this$pathAndType.path,
          type = _this$pathAndType.type;

      return [].concat(_toConsumableArray(documents)).filter(function (doc) {
        return doc.path === path && doc.type === type;
      });
    }, _this.folders = function () {
      var folders = _this.props.folders;
      var folder = _this.state.folder;
      return [].concat(_toConsumableArray(folders)).filter(function (f) {
        return f.path.length === folder.length && folder.join('/') === f.stringPath;
      });
    }, _this.handleClickOutside = function () {
      _this.setState({
        selected: []
      });
    }, _this.onSelect = function (docID) {
      var selected = _this.state.selected.includes(docID) ? [].concat(_toConsumableArray(_this.state.selected)).filter(function (id) {
        return id !== docID;
      }) : [].concat(_toConsumableArray(_this.state.selected), [docID]);

      _this.setState({
        selected: selected
      });
    }, _this.onRemove = function () {
      var selected = _this.state.selected;
      if (!selected.length) return;

      _this.props.onRemove(selected);
    }, _this.openDocs = function () {
      var selected = _this.state.selected;
      if (!selected.length) return;
      var files = [].concat(_toConsumableArray(_this.documents())).filter(function (doc) {
        return selected.includes(doc.id);
      }).map(function (doc) {
        return {
          id: doc.id,
          name: doc.name,
          file_format: doc.file_format,
          url: doc.document_file
        };
      });

      _this.setState({
        open: files
      });
    }, _this.closeDocs = function () {
      return _this.setState({
        open: []
      });
    }, _this.onStartEdit = function () {
      return _this.setState({
        selected: []
      });
    }, _this.onBack = function () {
      var folder = [].concat(_toConsumableArray(_this.state.folder));
      folder.pop();

      _this.setState({
        folder: folder,
        selected: []
      });
    }, _this.onFolder = function (folder) {
      return _this.setState({
        folder: [].concat(_toConsumableArray(_this.state.folder), [folder]),
        selected: []
      });
    }, _this.onUpload = function (files) {
      return _this.props.onUpload(files, _this.state.folder);
    }, _this.onShowUploader = function () {
      return _this.props.onShowUploader(_this.pathAndType());
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DocManager, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          loading = _props.loading,
          uploading = _props.uploading,
          updating = _props.updating,
          showUploader = _props.showUploader,
          onUpdate = _props.onUpdate,
          onHideUploader = _props.onHideUploader,
          fullscreen = _props.fullscreen,
          children = _props.children;
      var _state = this.state,
          open = _state.open,
          selected = _state.selected,
          folder = _state.folder;
      var documents = this.documents();
      var folders = this.folders();
      return _react2.default.createElement(_Container2.default, {
        fullscreen: fullscreen
      }, _react2.default.createElement(_Header2.default, {
        onBack: folder.length > 0 ? this.onBack : null,
        selected: selected,
        onOpen: this.openDocs,
        onRemove: this.onRemove,
        onShowUploader: this.onShowUploader
      }), _react2.default.createElement(_Grid2.default, {
        fullscreen: fullscreen
      }, folders.map(function (folder, index) {
        return _react2.default.createElement(_Folder2.default, {
          key: '' + folder.name + index,
          text: folder.name,
          onOpen: function onOpen() {
            return _this2.onFolder(folder.type);
          }
        });
      }), documents.map(function (doc) {
        return _react2.default.createElement(_File2.default, {
          key: doc.id,
          icon: doc.file_format === 'image' ? 'picture' : 'filetext1',
          thumbnail: doc.thumbnail_file,
          text: doc.name,
          selected: selected.includes(doc.id),
          onSelect: function onSelect() {
            return _this2.onSelect(doc.id);
          },
          onStartEdit: _this2.onStartEdit,
          onEdit: function onEdit(newText) {
            return onUpdate(doc.id, newText);
          },
          loading: updating.includes(doc.id),
          selectable: true,
          editable: true
        });
      }), loading && _react2.default.createElement(_File2.default, {
        key: 'fileloader',
        icon: 'loading2',
        text: 'Loading',
        loading: true
      }), !loading && !documents.length && !folders.length && _react2.default.createElement(_File2.default, {
        key: 'filesnotfound',
        icon: 'close',
        text: 'No Files Found'
      })), _react2.default.createElement(_FilePreview2.default, {
        files: open,
        visible: open.length > 0,
        onClose: this.closeDocs
      }), _react2.default.createElement(_Uploader2.default, {
        visible: showUploader,
        onClose: onHideUploader,
        uploading: uploading,
        onUpload: this.onUpload
      }, children));
    }
  }]);

  return DocManager;
}(_react.Component);

DocManager.propTypes = {
  loading: _propTypes2.default.bool,
  uploading: _propTypes2.default.bool,
  updating: _propTypes2.default.array,
  documents: _propTypes2.default.array,
  showUploader: _propTypes2.default.bool,
  onUpload: _propTypes2.default.func,
  onUpdate: _propTypes2.default.func,
  onRemove: _propTypes2.default.func,
  onShowUploader: _propTypes2.default.func,
  onHideUploader: _propTypes2.default.func,
  fullscreen: _propTypes2.default.bool,
  folders: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    name: _propTypes2.default.string,
    type: _propTypes2.default.string,
    stringPath: _propTypes2.default.string,
    path: _propTypes2.default.array,
    attributes: _propTypes2.default.array
  })),
  children: _propTypes2.default.node
};
DocManager.defaultProps = {
  loading: false,
  uploading: false,
  updating: [],
  documents: [],
  showUploader: false,
  fullscreen: false,
  folders: [],
  children: null
};
exports.DocManager = DocManager;
exports.default = (0, _reactOnclickoutside2.default)(DocManager);